// Merge unique objects from 2 arrays
export const mergeArraysUnique = (array1: any[], array2: any[]): any[] => {
  const result = [...array1, ...array2];
  const unique = result.reduce((acc, curr) => {
    if (!acc.some((item) => item.Value === curr.Value)) acc.push(curr);
    return acc;
  }, []);
  return unique;
};
